import { useEffect, useState } from "react";
import { getOrder } from "src/shared/services/servicesv2";

export function useOrder(orderId?: string) {
  const [order, setOrder] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!orderId) return;
    setLoading(true);
    getOrder(orderId)
      .then(res => setOrder(res.data.result))
      .catch(err => console.error(err))
      .finally(() => setLoading(false));
  }, [orderId]);

  return { order, loading };
}
